export const APISettings = {
  headers: {
    'Content-Type': 'application/json'
    // 'api-key': process.env.REACT_APP_SERVER_API_KEY,
    // 'client-id': process.env.REACT_APP_SERVER_CLIENT_ID
  },
  authHeaders: {
    'Content-Type': 'application/json'
  },
  apiServerURL: 'https://api.aihtifalevents.com/v1/'
  /* apiServerURL: ['https://'].includes(String(process.env.REACT_APP_API_URL))
     ? process.env.REACT_APP_SERVER_URL
     : process.env.REACT_APP_SERVER_URL?.replace('http://', 'https://')*/
};
